module.exports = __webpack_public_path__ + "static/8d9663db.LinkStore.png";